const StopwatchIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden className="shrink-0">
    <circle cx="12" cy="13.5" r="7.5" />
    <path d="M12 9.5v4l2.5 1.5M9.5 2.5h5M12 2.5V6" />
  </svg>
);

/** config.demandLine under a closed / failed booking box — same look as the «دبّه» box's line. */
export const DemandLine = ({ text }: { text?: string }) =>
  text ? (
    <span className="flex items-center gap-1 text-xs font-medium leading-5 text-amber-700" data-testid="local-specialists-demand">
      <span className="flex text-amber-600">
        <StopwatchIcon />
      </span>
      {text}
    </span>
  ) : null;

export default DemandLine;
